import zoneServices from "../../services/zoneServices";
import { classify, formFeedback } from "../../Utils/e5Messages";

// fields on the Zone form (400 errors for anything else show "Your changes were not saved.")
export const ZONE_FORM_FIELDS = [
  "zoneName",
  "zoneNumber",
  "timeZoneDetails",
  "scheduleFileBasePath",
  "verificationFileBasePath",
];

/**
 * @description create or update a zone; shared by Zone Overview and Zone Configuration
 * @param {*form values, already trimmed by the form} values
 * @param {*zone id on edit, empty on create} id
 * @param {* Bearer token for authentication} headerData
 * @returns {feedback, response, payload} feedback = formFeedback() result for the form
 */
export const saveZone = async (values, id, headerData) => {
  const data = JSON.parse(localStorage.getItem("userData"));
  const payload = {
    id: id ? id : 0,
    zoneNumber: values.zoneNumber.toString(),
    zoneName: values.zoneName,
    scheduleFileBasePath: values.scheduleFileBasePath,
    verificationFileBasePath: values.verificationFileBasePath,
    createdBy: data && data.id,
    timeZoneDetails: {
      id: values.timeZoneDetails ? parseInt(values.timeZoneDetails) : undefined,
    },
  };
  const response = await zoneServices.CreateOrUpdateZone(payload, headerData);
  return { feedback: formFeedback(classify(response), ZONE_FORM_FIELDS), response, payload };
};

export default saveZone;
